import { logger } from "@services/workers/helpers";
import ObjectsOperations from "@utils/objects/operations";
import type { AppDispatch } from "../../../store";
import { createApiDispatchers } from "..";

const namespace = "APIReducer";

// resetState to initial state
export const resetAPIReducer = (
	exceptions?: Array<string>,
	dispatch?: AppDispatch,
	getState?: () => any,
) => {
	if (!dispatch || !getState) {
		throw new Error("resetAPIReducer requires dispatch and getState functions");
	}

	const { dispatchResetAPI } = createApiDispatchers(dispatch);
	const exceptionsObj: any = {};
	const state = getState().api;

	if (exceptions && exceptions.length > 0) {
		exceptions.forEach((key) => {
			exceptionsObj[key] = ObjectsOperations.typeSafeStructuredClone(
				state[key as keyof typeof state],
			);
		});
	}

	dispatchResetAPI(exceptionsObj);

	logger.debug(namespace + "->" + resetAPIReducer.name, "Resetting state");
};
